import styled from "@emotion/styled";
import {font} from "../../styles/theme";

export const AdWrapper = styled.div(({grid}) => ({
  gridColumn: grid,
  display: "flex",
  justifyContent: "center",
  width: "100%",
}));

export const AdStickyWrapper = styled.button(() => ({
  position: "fixed",
  bottom: 8,
  zIndex: "100",
  display: "grid",
  gridColumn: "1/-1",
  marginInline: 8,
  aspectRatio: "16/9",
  width: "calc(100% - 16px)",
  minHeight: "202px",
  padding: 0,
  border: "0px",
}));
